module.exports = __webpack_public_path__ + "static/media/A2_17.2377994d.png";